export default __webpack_public_path__ + "static/media/any-language.82eabc64.mp3";